module.exports = __webpack_public_path__ + "img/0-10.7f431473.jpg";